import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export default class Usercarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
        };

    }


    render() {

        return (
            <div className="content-wrapper--wide">
                <div className="home__usercarousel-container">
                    <div className="home__usercarousel__title text-title">
                        {this.props.label}
                    </div>
                    <div className="home__usercarousel-wrapper">

                        {this.props.data && this.props.data.map((user, index) => (
                            <div key={index} className="home__usercarousel__element">
                                <div className="usercarousel__element__picture">
                                    <div className="usercarousel__element__picture-inner">
                                        Pic
                                    </div>
                                </div>
                                <div className="usercarousel__element__content">
                                    <div className="usercarousel__element__contentbox usercarousel__element__title">
                                        <Link to={"/u/oskards"} className="usercarousel__element__title-inner text-bold">
                                            oskards
                                        </Link>
                                    </div>
                                    <div className="usercarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                        {/* <div className="usercarousel__element__contentbox__icon"></div> */}
                                        <div className="usercarousel__element__contentbox__label">
                                            Hometown | Country
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                    </div>
                </div>
            </div>
        )
    }
}
